// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divSubirInforme[data-v-49795612]{padding:15px}.bPrincipal[data-v-49795612]{display:-webkit-box;display:-ms-flexbox;display:flex;float:right}", ""]);
// Exports
module.exports = exports;
